import { render } from "./App.vue?vue&type=template&id=6cbb07f7"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=6cbb07f7&lang=scss"

import exportComponent from "D:\\Google Drive\\info@colsysnet.com\\EMPRESAS\\COCOBU\\SOFTWARE\\academico\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__